module.exports = __webpack_public_path__ + "Roboto-Regular.ba3dcd8903e3d0af5de7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Regular.woff
// module id = 308
// module chunks = 2